import { ParsedMessagesInterface } from "@/interfaces/parsedMessages.interface";
import { ParseMessagesInterface } from "@/interfaces/parseMessages.interface";
import axios from "@/libs/axios";
// @ts-ignore
import i18n from "@/libs/i18n";
import { reactive, toRefs } from "@vue/composition-api";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/vue-query";

interface RootState {
    variables: Record<string, string[]>;
    loading: boolean;
    error: boolean;
}

const state: RootState = reactive({
    variables: {},
    loading: false,
    error: false,
});

export default function useParseMessage() {
    const parseMessage = (parseMessage: ParseMessagesInterface): Promise<ParsedMessagesInterface> =>
        axios.post("/parse-message", parseMessage).then((response) => response.data);
    const fetchVariables = (queryParams?: AxiosRequestConfig): void => {
        const { data, isLoading, isError } = useQuery(
            ["variables"],
            () => axios.get("/parse-message/variables", queryParams),
            {
                select: (response: { data: Record<string, string[]> }) => response.data,
                refetchOnWindowFocus: false,
                staleTime: 5000,
                placeholderData: { data: {} },
            } as any
        );

        // @ts-ignore
        state.loading = isLoading;
        // @ts-ignore
        state.variables = data;
        // @ts-ignore
        state.error = isError;
    };

    return {
        parseMessage,
        fetchVariables,
        ...toRefs(state),
    };
}
